const t = "buttons", o = "ds-button-navigation", S = "ds-button", _ = "ds-button-list-option";
export {
  t as TABS_TYPE_BUTTONS,
  o as TAB_CLASS_NAME,
  S as TAB_CLASS_NAME_BUTTONS,
  _ as TAB_CLASS_NAME_BUTTONS_SCREEN_SMALL
};
